









































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalBuatKonsul from "@/components/modal/CardModalBuatKonsul.vue";
import CardModalJawabKonsul from "@/components/modal/CardModalJawabKonsul.vue";
import CardModalAlasanBatalOrder from "@/components/modal/CardModalAlasanBatalOrder.vue";
import { storeKonsul } from "@/store/modules/konsul";
import { storeSoap } from "@/store/modules/soap";
// import User from "@/utility/User";
import { userModule } from "@/store/modules/user";
import http from "@/axios/http-common";
import moment from "moment";
import DataKonsul from "@/services/DataKonsul";
import { appModule } from "@/store/modules/app";
import SuratKonsul from "@/services/new/SuratKonsul";
import { confirmRemove } from "@/utility/CommonHelper";
@Component({
  components: {
    ModalBuatKonsul,
    CardModalJawabKonsul,
    CardModalAlasanBatalOrder
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardListSuratKonsul extends Vue {
  @Prop() register!: string;
  @Prop() kode!: string;
  @Prop() statedetailkonsul!: Array<object>;
  @Prop() panel!: Array<object>;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  modalOpenKonsul = false;
  modalJawabKonsul = false;
  sess_login = this.stateuser;
  dataKonsul = {};
  jwbKonsul = {};
  modalBatalKonsul = false;
  idKonsul = "";
  deletingJawaban = false;

  created() {
    // storeUnit.act_on_all_pagi();
    // storeKonsul.actKonsul_on_reg(this.register);
  }
  get stateuser() {
    return userModule.user;
  }
  get statekonsul() {
    return storeKonsul.konsul;
  }

  get stateloading() {
    return storeKonsul.loading;
  }

  get stateKonsulJawaban() {
    return this.statekonsul?.suratKonsul?.jawaban;
  }

  get stateKonsulJawabanSoap() {
    return this.stateKonsulJawaban.soap;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get statesoapalldokter() {
    return storeSoap.soapAll;
  }

  get statesoapperawat() {
    return storeSoap.detailSoap;
  }

  get canJawabKonsul() {
    if (this.readOnly) return false;
    return (
      this.statekonsul.suratKonsul.dokter_pengirim &&
      this.statekonsul.suratKonsul.dokter_pengirim.id != this.sess_login.id &&
      this.kode == "in"
    );
  }

  get canEdit() {
    if (this.readOnly) return false;
    return (
      this.statekonsul.suratKonsul.aktif == "1" &&
      ((this.statekonsul.suratKonsul.dokter_pengirim &&
        this.statekonsul.suratKonsul.dokter_pengirim.id ==
          this.sess_login.id) ||
        this.statekonsul.suratKonsul.creator_user_id == this.sess_login.id)
    );
  }

  ubahKonsul(val) {
    this.dataKonsul = val;
    this.modalOpenKonsul = true;
  }

  jawabKonsul(val) {
    this.jwbKonsul = val;
    this.modalJawabKonsul = true;
  }

  ubahJawabKonsul(val) {
    this.jwbKonsul = val;
    // storeKonsul.actKonsul_on_reg(this.register);
    this.modalJawabKonsul = true;
  }

  deleteJawabKonsul(val) {
    const konsul = val?.suratKonsul;

    if (
      !this.deletingJawaban &&
      confirmRemove("Jawaban Surat Rujukan Internal/Konsul")
    ) {
      this.deletingJawaban = true;

      SuratKonsul.deleteJawab(konsul.id)
        .then(resp => {
          if (resp.data.status) {
            appModule.NoticeDelay(resp.data.message);
            storeKonsul.actKonsul_on_reg(this.register);
          }
        })
        .finally(() => {
          this.deletingJawaban = false;
        });
    }
  }

  backPageSoap() {
    this.$emit("pageTab", "tab-soap");
  }

  cetakKonsul(val) {
    // alert(this.statedetailkonsul[0].id);
    // -----------------Ini yang asli jika sudah di Build--------------------
    // const routeData = this.$router.resolve({
    //   name: "cetakSuratKonsul",
    //   params: { id: this.statedetailkonsul[0].id },
    // });
    // window.open(routeData.href, "_blank");
    // -----------------^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^--------------------
    const routeData = http.getAPI() + "/surat-konsul/" + val["id"] + "/pdf";
    window.open(routeData, "_blank");
  }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }

  detailKonsul(val) {
    storeKonsul.SET_LOADING(true);
    storeKonsul.actKonsul_on_id(val);
  }
  closePanel(val) {
    // storeKonsul.SET_LOADING(true);
    // storeKonsul.actKonsul_on_id(val);
    this.panel = [];
  }

  batalKonsul(value) {
    this.idKonsul = value;
    this.modalBatalKonsul = true;
  }

  alasanBatal(val) {
    console.log("wwww");
    console.log("batal", val);
    const dt = DataKonsul.batalDataKonsul(val["id"], val["alasan"]);
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["data"]["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
        // console.log("gagal");
      } else {
        storeKonsul.actKonsul_on_reg(this.register);
        appModule.NoticeDelay("Berhasil Membatalkan Surat Rujukan Internal");
        this.panel = [];
      }
    });
  }
}
